export const options2 = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    autoplay: true,
    dots: false,
    autoplayTimeout: 2000, // 5 seconds
    smartSpeed: 1000, 
    navSpeed: 700,
    navText: ['Partners:', ''],
    margin: 24,
    responsive: {
      0: {
        items: 2
      },
      400: {
        items: 3
      },
      740: {
        items: 4
      },
      940: {
        items: 5
      }
    },
    nav: false
  };


export const typeoptions = {
    strings: ['Software Engineer', 'Developer'],
    typeSpeed: 100,
    backSpeed: 50,
    showCursor: true,
    cursorChar: '|',
    loop: true
};
